export function formatFilters(filters, countries, primaryKey = 'country_code') {
  const formatted = {};
  Object.keys(filters).forEach(key => {
    if (key === primaryKey) {
      const country = countries.find(c => c.code === filters[key]);
      if (country) {
        formatted['country'] = country.name;
      }
    } else {
      formatted[key] = filters[key];
    }
  });
  return formatted;
}

export const _ = null;

export function getCountryByValue(country_code) {
  return country_code.toLowerCase() == 'default' ? '*' : country_code;
}
export function resolveCountryCode(countryCode) {
  return countryCode === '*' ? 'default' : countryCode;
}

export function buildConfigMap(userConfig = []) {
  const map = {};
  for (const obj of userConfig) {
    map[obj.config_key] = obj.value;
  }
  return map;
}

export function getConfigMap() {
  return buildConfigMap(this.$auth?.userConfig || []);
}
